/**
 * PRICE FILTERS
*/

'use strict'
console.log('atFilters');

const lang = document.documentElement.lang;

function initPriceSlider() {
  const filtersForms = document.querySelectorAll('.facets__form');
  if (!filtersForms) return;
  const spacer = document.querySelector('#at_filter_inner');

  // function openFilter() {
  //     const spacerBtn = document.querySelector('#at_spacer_btn');
  //     const filterWrapper = document.querySelector('.facets-block-wrapper.facets-block-wrapper--horizontal');

  //     if (!spacerBtn || !filterWrapper) return;
  //     spacerBtn.addEventListener('click', (e) => {
  //         e.stopImmediatePropagation();
  //         filterWrapper.classList.toggle('open');
  //     });
  // }
  // openFilter();

  function deactivatedResultList() {
    const resultList = document.querySelector('#ResultsList');
    if (!resultList) return;
    const details = document.querySelectorAll('.facets--horizontal accordion-custom details .details-content');

    resultList.addEventListener('mouseenter', () => {
      details.forEach(element => {
        element.classList.add('transform');
      });
    });

    resultList.addEventListener('mouseleave', () => {
      details.forEach(element => {
        element.classList.remove('transform');
      });
    });

  }
  // deactivatedResultLis

  /** Prevent detail close */
  function mobFiltersDetailsClosed() {
    const container = document.querySelector('dialog-component#filters-drawer');
    if (!container) return;
    const details = container.querySelectorAll('details');
    details.forEach(detail => {
      detail.removeAttribute('open');
    });
  }
  mobFiltersDetailsClosed();

  filtersForms.forEach(filtersForm => {

    // const container = filtersForm.querySelector('.price-range-container');
    // let lists = filtersForm.querySelectorAll('.facets__inputs-wrapper .facets__inputs-list');
    const rangeMin = filtersForm.querySelector('#RangeMin');
    const rangeMax = filtersForm.querySelector('#RangeMax');
    const inputMin = filtersForm.querySelector('input[name="filter.v.price.gte"]');
    const inputMax = filtersForm.querySelector('input[name="filter.v.price.lte"]');
    const track = filtersForm.querySelector('.range-track');

    // const facetsPanels = filtersForm.querySelectorAll('.facets__panel');

    if (!rangeMin || !rangeMax || !inputMin || !inputMax) return;

    const minGap = 1000; // min step

    const k = 100;

    const updateTrack = () => {

      const max = parseInt(rangeMin.max) / k;
      const minVal = parseInt(rangeMin.value) / k;
      const maxVal = parseInt(rangeMax.value) / k;

      if (track) {
        track.style.left = ((minVal / max) * 100) + "%";
        track.style.right = (100 - ((maxVal / max) * 100)) + "%";
      }

    };

    const onRangeChange = (e) => {

      let minVal = parseInt(rangeMin.value / k);
      let maxVal = parseInt(rangeMax.value / k);

      if (maxVal - minVal < minGap) {
        if (e.target === rangeMin) rangeMin.value = maxVal - minGap;
        else rangeMax.value = minVal + minGap;
      }

      inputMin.value = inputMin.value = rangeMin.value / k;
      inputMax.value = inputMax.value = rangeMax.value / k;

      if (rangeMax.value > 50000000) inputMax.value = inputMax.max;

      updateTrack();

      inputMin.dispatchEvent(new Event('input', { bubbles: true }));
    };

    rangeMin.addEventListener('input', onRangeChange);
    rangeMax.addEventListener('input', onRangeChange);

    updateTrack();

    rangeMin.addEventListener('change', updateTrack);
    rangeMax.addEventListener('change', updateTrack);

    const clear = document.querySelector('.facets__form .clear-filter .facets__clear');
    if (!clear) return;
    clear.addEventListener('click', () => {
      updateTrack();
    });

    // =====
    function falseCheckRemove() {
      const checkboxes = filtersForm.querySelectorAll('.checkbox__input');
      checkboxes.forEach(checkbox => {
        if (checkbox.value === '0') checkbox.closest('li.facets__inputs-list-item').remove();
      });
    }
    // falseCheckRemove();

  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, initPriceSlider)
);
const initPriceSliderObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      initPriceSlider();
    }
  });
});
initPriceSliderObserver.observe(document.body, {
  childList: true,
  subtree: true
});

function initBrandSync() {
  const featuredCheckboxes = document.querySelectorAll('.featured-brand-sync');
  // console.log('featuredCheckboxes', featuredCheckboxes.length);
  // if (!featuredCheckboxes.length) document.querySelector('.featured-brands-selection.favorites').style.display = 'none';
  featuredCheckboxes.forEach(featuredCb => {
    const brandValue = featuredCb.dataset.brandValue;
    const originalCb = document.querySelector(`input[name="filter.p.vendor"][value="${brandValue}"]`) ||
      document.querySelector(`input[name="filter.v.price.vendor"][value="${brandValue}"]`);

    if (!originalCb) {
      featuredCb.closest('.featured-brand-item').style.display = 'none';
      featuredCb.closest('.featured-brands-selection.favorites').style.backgroundColor = 'transparent';
      // const a = featuredCb.closest('.featured-brand-item').style.display;
      // console.log('a', a !== 'none');
      return;
    }

    featuredCb.checked = originalCb.checked;

    featuredCb.onchange = (e) => {
      originalCb.click();
    };

    if (featuredCb.checked) {
      featuredCb.closest('.featured-brand-item').classList.add('active');
    } else {
      featuredCb.closest('.featured-brand-item').classList.remove('active');
    }

  });
}
['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, initBrandSync)
);
const initBrandSyncObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      initBrandSync();
    }
  });
});
initBrandSyncObserver.observe(document.body, {
  childList: true,
  subtree: true
});

function checkboxRename() {
  const containers = document.querySelectorAll('floating-panel-component#facet-inputs-filter-p-m-custom-gender');
  containers.forEach(container => {
    const facetsPanel = container.closest('details.facets__panel');
    const facetStatus = facetsPanel.querySelector('.facets__status span[ref="facetStatus"]:not(.facets__bubble, [data-at-processed="true"])');
    const checkboxes = container.querySelectorAll('.checkbox__input:not([data-at-processed="true"]');
    // console.log('lang', lang);
    let FOR_HIM = 'For him';
    let FOR_HER = 'For her';
    if (lang === 'de') {
      FOR_HIM = 'Für ihn';
      FOR_HER = 'Für sie';
    }

    checkboxes.forEach(checkbox => {
      const label = checkbox.closest('li.facets__inputs-list-item').querySelector('span.checkbox__label-text');

      if (checkbox.value === '0') {
        label.textContent = FOR_HIM;
        checkbox.setAttribute('data-at-processed', true);
        if (facetStatus && checkbox.checked) {
          facetStatus.textContent = FOR_HIM;
          facetStatus.setAttribute('data-at-processed', true);
        }
      }

      if (checkbox.value === '1') {
        label.textContent = FOR_HER;
        checkbox.setAttribute('data-at-processed', true);
        if (facetStatus && checkbox.checked) {
          facetStatus.textContent = FOR_HER;
          facetStatus.setAttribute('data-at-processed', true);
        }
      }
    });
  });
}

['DOMContentLoaded', 'shopify:section:load'].forEach(event =>
  document.addEventListener(event, checkboxRename)
);
const checkboxRenameObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      checkboxRename();
    }
  });
});
checkboxRenameObserver.observe(document.body, {
  childList: true,
  subtree: true
});
